import { useQuery } from '@tanstack/react-query';
import dataService from 'services/dataService';
import { useState } from 'react';
import { useDebounce } from 'react-use';

import { useLinkCallReadingsToolFilters } from './use-link-call-readings-tool-filter';
import { apiUrlGenerator } from '../use-api';

import type { IGetData, ILinkCallReadingsToolResponse } from './types';

const url = 'calls/link-call-readings-tool';
export const LINK_CALL_READINGS_PER_PAGE = 100;

const queryFn = async (filter: IGetData) => {
  const { error, data } =
    await dataService.getList<ILinkCallReadingsToolResponse>(
      apiUrlGenerator(url, filter),
    );

  if (error) {
    return Promise.reject(error);
  }

  return data;
};

export const queryKeyBase = ['getLinkCallReadingsToolData'] as const;

export const useGetLinkCallReadingsToolData = () => {
  const { filter } = useLinkCallReadingsToolFilters();
  const [debouncedFilter, setDebouncedFilter] = useState(filter);

  useDebounce(() => setDebouncedFilter(filter), 300, [filter]);

  const queryKey = [...queryKeyBase, debouncedFilter] as const;

  const { data, error, isLoading, isPreviousData, isRefetching } = useQuery<
    ILinkCallReadingsToolResponse | undefined,
    string | undefined
  >({
    queryKey,
    queryFn: () =>
      queryFn({ ...debouncedFilter, items: LINK_CALL_READINGS_PER_PAGE }),
    keepPreviousData: true,
  });

  return {
    data,
    isLoading: isLoading || isPreviousData || isRefetching,
    error,
  };
};
